import api, { unwrap } from './client';

// Admin-side clinic approval queue (Phase 4).

export async function listClinics(params = {}) {
  return unwrap(await api.get('/admin/clinics', { params }));
}

export async function listPendingClinics() {
  return unwrap(await api.get('/admin/clinics/pending'));
}

export async function getClinic(id) {
  return unwrap(await api.get(`/admin/clinics/${id}`));
}

export async function approveClinic(id) {
  return unwrap(await api.put(`/admin/clinics/${id}/approve`));
}

export async function rejectClinic(id, reason) {
  return unwrap(await api.put(`/admin/clinics/${id}/reject`, { reason }));
}

export async function suspendClinic(id, reason) {
  return unwrap(await api.put(`/admin/clinics/${id}/suspend`, { reason }));
}

// Returns the API path; consumer can render in <a href> with auth handled
// by the axios interceptor — but the streaming endpoint sets inline headers,
// so directly opening it requires the auth header. Use api.get(...) with
// responseType:'blob' for safe download/preview.
export async function fetchClinicDocumentBlob(clinicId, kind) {
  const res = await api.get(`/admin/clinics/${clinicId}/documents/${kind}/file`, {
    responseType: 'blob',
  });
  return res.data;
}
